
import { getHostBaseUrl } from '@/helpers/env'
import querystring from 'querystring'
import axios from 'axios'
import {
  OLO_APPLICATION_NAME_HEADER,
  OLO_APPLICATION_NAME_VALUE,
} from '@/constants/api'

const HOST_API_BASE_URL = getHostBaseUrl()

const hostApi = axios.create({
  baseURL: HOST_API_BASE_URL,
  headers: {
    [OLO_APPLICATION_NAME_HEADER]: OLO_APPLICATION_NAME_VALUE,
  }
})

export const API_URL_RESERVATIONS_STATUS = 'reservations_widget/closures'

export const constructMerchantReservationWidgetStatusUrl = function (merchantId: string) {
  return `/${API_URL_RESERVATIONS_STATUS}?${querystring.stringify({ merchant_id: merchantId })}`
}

export default hostApi
